// extracted by mini-css-extract-plugin
export default {"heading":"Courses_heading__XFYG2","courses_container":"Courses_courses_container__Q+8e4","card_container":"Courses_card_container__Q3AOb","courses":"Courses_courses__kFSBP"};